import NavbarSection from "../components/NavbarSection";
import HeroSection from "../components/HeroSection";
import DeductionSection from "../components/DeductionSection";
import Stages from "../components/ThirdSection";
import FeaturesSection from "../components/FeaturesSection";
import FooterSection from "../components/FooterSection";
import TestimonySection from "../components/TestimonySection";
import SecuritySection from "../components/SecuritySection";
import SavingSection from "../components/SavingSection";
import VECTOR2 from "../assets/Vector2.png";
import VECTOR1 from "../assets/Vector1.png";
 
const Home = () => {
  return (
    <>
      <div id="top-page" className="position-relative page-position-style">
        {/* <img src={VECTOR1} alt="Curve Vector" className="curve-vector1" />
        <img src={VECTOR2} alt="Curve Vector" className="curve-vector2" /> */}

        <div className="vector-layer">
          <NavbarSection />
          <HeroSection />
        </div>
      </div>

      <div className="position-relative page-position-style">
        <img src={VECTOR1} alt="Curve Vector" className="curve-vector1" />
        <img src={VECTOR2} alt="Curve Vector" className="curve-vector2" />

        <div className="vector-layer">
          <DeductionSection />
        </div>
      </div>

      <div id="about">
        <Stages />
      </div>

      <div id="features">
        <FeaturesSection />
      </div>

      <div id="reviews">
        <TestimonySection />
      </div>

      <SavingSection />
      <SecuritySection />
      <FooterSection />
    </>
  );
};

export default Home;
